"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncludedModuleInfo = void 0;
/* eslint-disable require-jsdoc */
const firestore_1 = require("firebase/firestore");
const types_1 = require("../main/types");
class IncludedModuleInfo extends types_1.IncludedModuleInfoType {
    constructor(moduleId, includedDate) {
        super(moduleId);
        this.includedDate = firestore_1.Timestamp.now();
        this.includedDate = includedDate;
    }
}
exports.IncludedModuleInfo = IncludedModuleInfo;
IncludedModuleInfo.converter = {
    toFirestore(data) {
        return {
            includedDate: data.includedDate,
            isAssigned: data.isAssigned
        };
    },
    fromFirestore(snapshot) {
        var _a;
        const documentData = snapshot.data();
        const moduleId = snapshot.id;
        const includedDate = documentData.includedDate;
        const isAssigned = (_a = documentData.isAssigned) !== null && _a !== void 0 ? _a : false;
        const data = new IncludedModuleInfo(moduleId, includedDate);
        data.isAssigned = isAssigned;
        return data;
    }
};
